<template>
  <div class="guest-interests">
    <h2 class="h1">Guest interests</h2>
    <table class="standard-table with-lines">
      <tr>
        <th><span class="absolute-wrapper">Pages</span></th>
        <th><span class="absolute-wrapper">Clicks</span></th>
      </tr>
      <tr v-for="(clickedBox, index) in paginatedClicks" :key="index">
        <td>{{ clickedBox[0] }}</td>
        <td>{{ clickedBox[1] }}</td>
      </tr>
      <tr class="page-count-row">
        <td colspan="2" class="page-count-container">
          {{ clicksNumber + 1 }} / {{ clicksCount }}
        </td>
      </tr>
      <div class="page-arrows-container" v-if="totalClicks.length > 5">
        <button @click="previousInterests" :disabled="clicksNumber <= 0">
          &lt;
        </button>
        <button
          @click="nextInterests"
          :disabled="clicksNumber >= clicksCount - 1"
        >
          &gt;
        </button>
      </div>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    statistics: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      size: 5,
      clicksNumber: 0,
    };
  },
  computed: {
    totalClicks() {
      return this.filterClicks(this.statistics);
    },
    clicksCount() {
      let l = this.totalClicks.length,
        s = this.size;
      return Math.ceil(l / s);
    },
    paginatedClicks() {
      const start = this.clicksNumber * this.size,
        end = start + this.size;
      return this.totalClicks.slice(start, end);
    },
  },
  methods: {
    nextInterests() {
      this.clicksNumber++;
    },
    previousInterests() {
      this.clicksNumber--;
    },
    filterClicks(fullDataArray) {
      const arrayOfClickObject = [];
      for (let singleDate of fullDataArray) {
        arrayOfClickObject.push(singleDate[2]["singleDayBoxObject"]);
      }
      return Object.entries(
        arrayOfClickObject.reduce(this.reduceClicks, {})
      ).sort((a, b) => b[1] - a[1]);
    },
    reduceClicks(bigObject, singleObject) {
      for (var key in singleObject) {
        bigObject[key] = (bigObject[key] || 0) + singleObject[key];
        singleObject[key];
      }
      return bigObject;
    },
  },
};
</script>

<style scoped>
table {
  position: relative;
}

.page-arrows-container {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
}

.page-arrows-container button {
  width: 32px;
  height: 32px;
  background-color: var(--primary);
  color: var(--light);
  border-radius: 50%;
  position: relative;
}

.page-arrows-container button:first-child {
  left: -16px;
}

.page-arrows-container button:last-child {
  right: -16px;
}

.page-arrows-container button:disabled {
  background-color: var(--primary-disabled);
}

tr td.page-count-container {
  color: var(--grey);
  text-align: center;
}

.standard-table.with-lines tr.page-count-row {
  background: none;
}
</style>
